module.exports = __webpack_public_path__ + "img/kkii4324.45db329c.jpg";